export default "__VITE_ASSET__CXUT8iB4__"